import { Box, Container, Flex, HStack } from '@chakra-ui/react'
import React, { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { BackButton } from 'ui'

export interface DetailPageHeaderContainerProps {
  children: ReactNode | ReactNode[]
}

function DetailPageHeaderContainer({ children }: DetailPageHeaderContainerProps): ReactElement {
  return (
    <>
      <Box bgColor="deepblue.10" marginBottom={14}>
        <Container position="relative" pt={{ base: 4, lg: 10 }} pb={14}>
          <BackButton mb={{ base: 5, lg: 8 }} />
          {children}
        </Container>
      </Box>
    </>
  )
}

DetailPageHeaderContainer.Header = function DetailPageHeaderHeaderContainer({
  children,
}: PropsWithChildren<DetailPageHeaderContainerProps>): ReactElement {
  return <Box mb={{ base: '35px', lg: '50px' }}>{children}</Box>
}

DetailPageHeaderContainer.Details = function DetailPageHeaderDetailsContainer({
  children,
}: PropsWithChildren<DetailPageHeaderContainerProps>): ReactElement {
  return (
    <HStack
      spacing={[5, 9, 9, 14]}
      mr={{ base: -4, lg: 'unset' }}
      overflow="auto"
      whiteSpace="nowrap"
      alignItems="flex-start"
      sx={{
        'html[lang=ar] &': {
          mr: 'unset',
          ml: { base: -4, lg: 'unset' },
        },
      }}
    >
      {children}
    </HStack>
  )
}

DetailPageHeaderContainer.CtaButtons = function DetailPageHeaderCtaButtonContainer({
  children,
}: PropsWithChildren<DetailPageHeaderContainerProps>): ReactElement {
  return (
    <Flex
      mt={{ base: '35px', md: 10 }}
      flexDirection={{ base: 'column', md: 'row' }}
      sx={{
        '& > :not(:last-child, :only-child)': {
          mr: { md: '10px' },
          mb: { base: '10px', md: 'unset' },
          'html[lang=ar] &': {
            mr: 'unset',
            ml: { md: '10px' },
          },
        },
      }}
    >
      {children}
    </Flex>
  )
}

export default DetailPageHeaderContainer
